module.exports = __webpack_public_path__ + "img/need-help-widget.svg";